import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../../../../../environments/environment.prod";
import {WarehouseService} from "../../../../../services/warehouse/warehouse.service";

@Component({
  selector: 'app-reset-stock',
  templateUrl: './reset-stock.component.html',
  styleUrls: ['./reset-stock.component.scss']
})
export class ResetStockComponent implements OnInit {
  @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
  @Input() entrepotId: number | null = null;
  @Output() stockReset = new EventEmitter<void>();

  private modalRef!: NgbModalRef;
  public passwordTextTypeNew = false;
  public passwordTextTypeRetype = false;
  public password: string = '';
  public loading = false;
  public passwordError: string = '';
  file: string = environment.file_url;

  constructor(private modalService: NgbModal,
              private warehouseService: WarehouseService,
              private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  openModal() {
    this.password = '';
    this.passwordError = '';
    this.loading = false;
    const options: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      keyboard: true,
      size: 'lg',
    };
    this.modalRef = this.modalService.open(this.modalTemplate, options);
  }

  togglePasswordTextTypeNew() {
    this.passwordTextTypeNew = !this.passwordTextTypeNew;
  }

  onPasswordChange(): void {
    if (this.passwordError) {
      this.passwordError = '';
    }
  }

  private clearPasswordBeforeClose(): void {
    this.password = '';
    this.passwordError = '';
  }

  confirmReset(): void {
    if (this.loading) {
      return;
    }
    if (!this.password || !this.password.trim()) {
      this.passwordError = 'Veuillez saisir votre mot de passe';
      return;
    }
    if (this.entrepotId == null) {
      this.toastr.error('Entrepôt non spécifié', 'Erreur');
      return;
    }

    const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    const userId = currentUser?.id;
    if (!userId) {
      this.toastr.error('Utilisateur non authentifié', 'Erreur');
      return;
    }

    this.passwordError = '';
    this.loading = true;
    this.warehouseService.resetStockEntrepot(this.entrepotId, userId, this.password).subscribe({
      next: () => {
        this.loading = false;
        this.clearPasswordBeforeClose();
        this.modalRef?.close();
        this.stockReset.emit();
        this.toastr.success('Stock réinitialisé avec succès !', '', {
          positionClass: 'toast-bottom-right',
          toastClass: 'toast ngx-toastr custom-success-toast',
        });
      },
      error: (err) => {
        this.loading = false;
        const status = err?.status;
        const apiMsg = err?.error?.message || err?.error?.error;
        if (status === 401 || status === 403) {
          this.passwordError = 'Mot de passe incorrect';
        } else if (status === 400 && apiMsg && /password|mot de passe/i.test(String(apiMsg))) {
          this.passwordError = apiMsg;
        } else {
          this.toastr.error(apiMsg || 'Erreur lors de la réinitialisation du stock', 'Erreur');
        }
      }
    });
  }
}
